// Initial settings used with first install
const initialSettingsData = {
  createdAt: Date.now(),
  vueAppVersion: '0.0.0',
  //
  // Global App permissions
  //
  trackingAllowed: false,
  //
  // Permission Status
  //
  geolocationPermissionStatus: 'prompt',
  //
  // Geolocation specifics
  //
  enableHighAccuracy: false,
  maximumAge: 0,
  timeout: 5000,
  //
  // Geolocation Recording constrains
  //
  useMinSpeedThreshold: false,
  minSpeedThreshold: 0.9,
  useRecordingTimeInterval: false,
  recordingTimeInterval: 1500,
  // Live map updates mode: 'off' | 'auto' | 'always'
  // Controls marker/follow updates during recording (does not affect what gets recorded)
  liveUpdateMode: 'auto',
  //
  // Notifications
  //
  showNotificationWhenNotMoving: false,
  //
  // Screen Wake-Lock Web API
  //
  screenWakeLockAvailability: false,
  //
  // Touch Screen Protection
  //
  useTouchScreenProtection: false,
  touchScreenProtectionActive: false,
  //
  // Reverse Geolocation
  //
  addressService: 'none',
  reverseGeoLocServices: ['none', 'nomatim', 'HERE', 'Google'],
  //
  // Zoom (OpenLAyers)
  //
  zoomLevelFar: 0,
  zoomLevelNear: 14,
  //
  // Fallback Location (for development without GPS)
  //
  fallbackLatitude: 48.2082, // Vienna, Austria
  fallbackLongitude: 16.3738,
  //
  // Pagination (Sidebar Sections)
  //
  maxMapHostsPerPage: 7,
  maxNotesPerPage: 7,
  maxTrackedRoutesPerPage: 12,
  //
  // Track Studio Settings
  //
  maxTracksToMerge: 10,
  maxTracksToOverlay: 10,
  maxRoutesForComparison: 10,
  // Rest detection thresholds for Compare Routes
  restSpeedThresholdKmh: 1.0,
  restMinDurationSec: 120,
  //
  // POI map interaction settings
  //
  poiCreateHoldDurationMs: 1000,
  poiCreateHoldMoveTolerancePx: 8,
  //
  // Speech Recognition
  //
  useSpeechRecognition: false,
  speechRecognitionSelectedLanguage: 'en-US',
  //
  // Debugging
  //
  console: false,
  debugging: false,
  log: ''
  // TODO: impement later
  //
  // Sensors: Gyroscope Web API
  //
  // gyroscopePermissionStatus: 'prompt',
  // useSteps: false,
  // sensorsAllowed: false,
};

export default initialSettingsData;
